import React, { useState } from "react";

import { getToken } from "../../../../api/Account";
import { addAdelantoAsync } from "../../../../api/Employees";
import { useAviso } from "../../../../components/base";
import {
  CampoMonto,
  DialogoFormulario,
  esMontoEscribible,
  useEnvio,
  useEscritura,
} from "../comunes";

const AddAdelanto = ({ id, setShowModal, reload, setReload }) => {
  const [monto, setMonto] = useState("");
  const [intentado, setIntentado] = useState(false);

  const token = getToken();
  const aviso = useAviso();
  const escribir = useEscritura();
  const { guardando, enviar } = useEnvio();

  const saveChanges = () =>
    enviar(async () => {
      setIntentado(true);
      if (monto.length === 0) return;

      const data = {
        employeeId: id,
        monto,
      };

      const ok = await escribir(
        () => addAdelantoAsync(token, data),
        "No se pudo agregar el adelanto"
      );
      if (!ok) return;
      aviso.exito("Adelanto agregado");
      setReload(!reload);
      setShowModal(false);
    });

  //Devuelve un entero positivo
  const funtionSetMonto = (value) => {
    if (esMontoEscribible(value)) {
      setMonto(value);
    }
  };

  return (
    <DialogoFormulario
      titulo="Agregar adelanto"
      onCerrar={() => setShowModal(false)}
      hayCambios={monto !== ""}
      guardando={guardando}
      onEnviar={saveChanges}
      textoEnviar="Agregar adelanto"
    >
      <CampoMonto
        autoFocus
        required
        label="Monto del adelanto"
        value={monto}
        onChange={funtionSetMonto}
        error={intentado && monto.length === 0 ? "Ingrese el monto del adelanto" : ""}
        disabled={guardando}
        sx={{ mt: 1 }}
      />
    </DialogoFormulario>
  );
};

export default AddAdelanto;
